// src/components/store/sections/weekly-banner/Variant1ClassicDark.tsx
"use client";

import Image from "next/image";
import Link from "next/link";
import { ArrowRight, Sparkles } from "lucide-react";
import { WeeklyBannerProps } from "./types";

export default function Variant1ClassicDark({ banner, subdomain }: WeeklyBannerProps) {
  const imageUrl = banner?.image
    ? banner.image.startsWith("http") || banner.image.startsWith("data:")
      ? banner.image
      : `http://${subdomain ? `${subdomain}.` : ""}localhost:8000${banner.image.startsWith("/") ? "" : "/"}${banner.image}`
    : "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=800&auto=format&fit=crop&q=80";

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 select-none font-sans">
      <div className="rounded-[36px] bg-[#0c1322] border border-slate-800/80 p-8 sm:p-14 flex flex-col md:flex-row items-center justify-between gap-8 overflow-hidden relative shadow-2xl group transition-all">
        <div className="absolute -left-20 -bottom-20 w-80 h-80 rounded-full bg-emerald-500/10 blur-3xl pointer-events-none" />

        <div className="space-y-4 max-w-xl z-10 text-left">
          <span className="text-[11px] font-black text-emerald-400 uppercase tracking-widest inline-flex items-center gap-1.5 bg-emerald-950/60 border border-emerald-500/30 px-3.5 py-1.5 rounded-full shadow-inner">
            <Sparkles className="w-3.5 h-3.5 text-emerald-400" />
            {banner?.badge_title || "FLAT 20% DISCOUNT"}
          </span>

          <h2 className="text-3xl sm:text-5xl font-black text-white leading-tight tracking-tight">
            {banner?.title || "Purely Fresh Vegetables"}
          </h2>

          <p className="text-xs sm:text-sm text-slate-300 leading-relaxed max-w-md font-medium">
            {banner?.subtitle ||
              "100% organic farm picked fresh harvest delivered to your doorstep across the nation."}
          </p>

          <div className="pt-2">
            <Link
              href={banner?.target_url || "/products"}
              className="px-8 py-3.5 rounded-full bg-emerald-500 hover:bg-emerald-400 text-slate-950 font-black text-xs inline-flex items-center gap-2 transition-all shadow-lg shadow-emerald-500/30 active:scale-95 cursor-pointer"
            >
              <span>{banner?.button_text || "Shop Now"}</span>
              <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>

        <div className="w-72 sm:w-[420px] aspect-[4/3] relative flex-shrink-0 flex items-center justify-center">
          <div className="absolute w-56 h-12 rounded-full bg-black/60 blur-xl bottom-4" />
          <Image
            src={imageUrl}
            alt={banner?.title || "Weekly Banner"}
            fill
            unoptimized
            className="object-contain drop-shadow-[0_20px_25px_rgba(0,0,0,0.7)] group-hover:scale-105 transition-transform duration-500"
          />
        </div>
      </div>
    </section>
  );
}

export { Variant1ClassicDark };